module.exports = __webpack_public_path__ + "static/media/icon-passo1.f27837d7.svg";